import { render, staticRenderFns } from "./ExportTranslationJsonModal.vue?vue&type=template&id=aa03f770&scoped=true&"
import script from "./ExportTranslationJsonModal.vue?vue&type=script&lang=js&"
export * from "./ExportTranslationJsonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa03f770",
  null
  
)

export default component.exports